import React from 'react';

import { Box, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

interface MenuLinkItemProps {
  href: string;
  name: string;
  analyticsName: string;
  isActive?: boolean;
  onPress?: () => void;
  showOnTablet?: boolean;
  tabletDisplay?: string;
  isLast?: boolean;
  icon?: React.ReactNode;
  variant?: 'public' | 'account';
}

export const MenuLinkItem: React.FC<MenuLinkItemProps> = ({
  href,
  name,
  analyticsName,
  isActive,
  onPress,
  isLast,
  icon,
  variant = 'public',
}) => {
  return (
    <Text
      as="li"
      className={cn(
        'min-[1024px]:hidden',
        variant === 'public' && !isLast && 'border-b border-od-border-secondary',
      )}
    >
      <Row
        href={href}
        aria-current={isActive}
        aria-label={name}
        analyticsName={analyticsName}
        onClick={onPress}
        className={cn(
          'items-center gap-2',
          variant === 'account'
            ? 'min-h-12 rounded-lg py-3 pr-1 hover:bg-od-bg-hover-primary'
            : 'py-4',
          isActive && 'bg-od-bg-hover-primary',
        )}
      >
        {icon && <Box className="h-5 w-5 shrink-0 items-center justify-center">{icon}</Box>}
        <Text
          as="span"
          className={
            variant === 'account'
              ? 'min-w-0 truncate text-body-md'
              : 'text-lg leading-[1.45] tracking-[-0.024em]'
          }
        >
          {name}
        </Text>
      </Row>
    </Text>
  );
};
